export default [
  {
    id: '1006',
    name: '4 week saver',
    duration: '4 weeks',
    price: '25.99',
    original_price: '29.99',
    selling_points: {
      bold: [
        '93p per day',
        'Pause your upgrade (once per 4 week saver)',
        'Extra listings can be purchased (see below)',
      ],
      early_bird: [
        'Success guaranteed (or get another 4 weeks free)',
        'Pause your upgrade (once per 4 week saver)',
        'Only 93p per day',
      ],
    },
  },
  {
    id: '1005',
    name: '2 weeks',
    duration: '2 weeks',
    price: '21.99',
    selling_points: {
      bold: ['£1.57 per day', '74% of people fill their room within 2 weeks'],
      early_bird: [
        '54% of people find a place within 2 weeks',
        '£1.57 per day',
      ],
    },
  },
  {
    id: '1004',
    name: '1 week',
    duration: '1 week',
    price: '11.99',
    selling_points: {
      bold: ['£1.71 per day', '40% of people fill their room within 7 days'],
      early_bird: [
        '36% of people find somewhere within 7 days',
        '£1.71 per day',
      ],
    },
  },
];
